module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-user-item iconfont",
      class: {
        selected: item.name == _vm.tab
      },
      on: {
        "click": function($event) {
          return _vm.handleTabClick(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "l-user-item-icon",
      class: item.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "l-user-item-text"
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88141bec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88141bec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/user/LeftBar.vue
// module id = 1594
// module chunks = 7